module.exports = __webpack_public_path__ + "img/vignettes-asso_0007_le-ptit-cerny.c12c7e17.jpg";